// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".selectable-list{padding:5px}.selectable-list .form-field.checkbox{padding-left:5px;transition:background .1s ease}.selectable-list .form-field.checkbox:hover{background:rgba(0,0,0,.05)}.selectable-list .color{background-color:var(--c);border-radius:50%;box-shadow:0 0 1px rgba(0,0,0,.5);height:20px;margin-right:10px;width:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
